import { AppThemeProvider, DefaultThemeWithFonts } from '@hqo/react-components-library/dist/molecules/theme/';
import { useDispatch } from 'react-redux';

import { AppContentWrapperStyles } from 'components/app-content-wrapper/app-content-wrapper.styles';
import { CustomFonts } from 'components/custom-fonts';
import React from 'react';

import { setFeatureFlags } from 'store/featureFlags/actions';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useGetTheme } from 'hooks/use-get-theme.hook';

interface AppContentWrapperProps {
  children: React.ReactNode;
}

export const AppContentWrapper = ({ children }: AppContentWrapperProps): JSX.Element => {
  const dispatch = useDispatch();
  const lDFlags = useFlags();
  dispatch(setFeatureFlags(lDFlags));
  const theme = useGetTheme();

  return (
    <>
      {/* @ts-ignore */}
      <AppContentWrapperStyles customThemeFonts={theme.fonts} />
      <CustomFonts />
      <AppThemeProvider theme={theme as DefaultThemeWithFonts}>{children}</AppThemeProvider>
    </>
  );
};
